function cov_yqvuxz3t9() {
  var path = "/app/src/utils/get-is-mobile-webview.ts";
  var hash = "5f3d4d75687366dee48cd0484a59d722f3ae55e7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-is-mobile-webview.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 34
        },
        end: {
          line: 10,
          column: 3
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 10,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 34
          },
          end: {
            line: 3,
            column: 35
          }
        },
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 4
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 9,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 5,
            column: 42
          }
        }, {
          start: {
            line: 6,
            column: 6
          },
          end: {
            line: 6,
            column: 57
          }
        }, {
          start: {
            line: 7,
            column: 6
          },
          end: {
            line: 7,
            column: 31
          }
        }, {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 27
          }
        }, {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 29
          }
        }],
        line: 5
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5f3d4d75687366dee48cd0484a59d722f3ae55e7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_yqvuxz3t9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_yqvuxz3t9();
import isWebview from 'is-ua-webview';
cov_yqvuxz3t9().s[0]++;
export var getIsMobileWebview = function getIsMobileWebview() {
  var _window$navigator, _window;
  cov_yqvuxz3t9().f[0]++;
  cov_yqvuxz3t9().s[1]++;
  return Boolean((cov_yqvuxz3t9().b[0][0]++, isWebview((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent)) || (cov_yqvuxz3t9().b[0][1]++, (_window = window) === null || _window === void 0 || (_window = _window.webkit) === null || _window === void 0 || (_window = _window.messageHandlers) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView) || (cov_yqvuxz3t9().b[0][2]++, window.ReactNativeWebView) || (cov_yqvuxz3t9().b[0][3]++, window.tabbyMobileSDK) || (cov_yqvuxz3t9().b[0][4]++, window.tabbyAppListener));
};